<template>
  <el-container id='wrapper'>
    <el-header>
      <PageTitle title="Settings" disableDateTime></PageTitle>
    </el-header>
    <el-main class="main">
      <div class="container">
        <div class="content">
          <router-link to="/users">Manage Users</router-link><br />
          <router-link to="/roles">Manage Roles</router-link>
        </div>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import PageTitle from '../components/PageTitle'

export default {
  components: {
    PageTitle
  },
  data () {
    return {
    }
  },
  computed: {

  },
  mounted () {

  },

  watch: {

  }
}
</script>

<style lang='scss' scoped>
@import "../styles/common.scss";
.main {
  display: flex;
  align-items: stretch;
  padding-top: 0px;

  .container {
    display: flex;
    flex-grow: 1;
    align-items: stretch;
    background-color: white;
    border-radius: 10px;
    
    .content {
      padding: 20px;
      line-height: 25px;
    }
  }
}
</style>
